import { render } from "./AddNewProject.vue?vue&type=template&id=bb4683fe"
import script from "./AddNewProject.vue?vue&type=script&lang=js"
export * from "./AddNewProject.vue?vue&type=script&lang=js"
script.render = render

export default script